import { render, staticRenderFns } from "./PromotionType.vue?vue&type=template&id=a63cb114"
import script from "./PromotionType.vue?vue&type=script&lang=js"
export * from "./PromotionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports